import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "sobre-mim",
  class: "about-section"
}
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "section-subtitle" }
const _hoisted_6 = { class: "section-subtitle mt" }
const _hoisted_7 = { class: "section-subtitle mt" }
const _hoisted_8 = ["aria-label"]
const _hoisted_9 = ["aria-label"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useLocalized } from '@/composables/useLocalized';
import { profile } from '@/data/profile';
import { courses } from '@/data/courses';
import { skillKeywords } from '@/data/seo';


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutSection',
  setup(__props) {

const { pick } = useLocalized();
const { tm } = useI18n();

const journeyItems = computed(() => tm('about.journey.items') as string[]);

return (_ctx: any,_cache: any) => {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('sections.about')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('about.subtitleIntro')), 1),
      _createElementVNode("p", null, [
        _createVNode(_component_i18n_t, {
          keypath: "about.intro1",
          tag: "span"
        }, {
          name: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("strong", null, "Danilo", -1)
          ]))]),
          role: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_unref(pick)(_unref(profile).i18n).profession), 1)
          ]),
          designDigital: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.designDigital')), 1)
          ]),
          webFlash: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.webFlash')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_i18n_t, {
          keypath: "about.intro2",
          tag: "span"
        }, {
          softwareFocus: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.softwareFocus')), 1)
          ]),
          products: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.products')), 1)
          ]),
          telecom: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.telecom')), 1)
          ]),
          marketplaces: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.marketplaces')), 1)
          ]),
          institutions: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.institutions')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_i18n_t, {
          keypath: "about.intro3",
          tag: "span"
        }, {
          unicef: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("strong", null, "UNICEF", -1)
          ]))]),
          porto: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("strong", null, "Porto Seguro", -1)
          ]))]),
          tenda: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createElementVNode("strong", null, "Tenda", -1)
          ]))]),
          ifood: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("strong", null, "iFood", -1)
          ]))]),
          claro: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("strong", null, "Claro", -1)
          ]))]),
          technicalDecisions: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.technicalDecisions')), 1)
          ]),
          performance: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.performance')), 1)
          ]),
          automatedTests: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.automatedTests')), 1)
          ]),
          pipelineQuality: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.pipelineQuality')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('about.subtitleJourney')), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(journeyItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(item), 1))
      }), 128)),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('about.subtitleWorkflow')), 1),
      _createElementVNode("p", null, [
        _createVNode(_component_i18n_t, {
          keypath: "about.workflow",
          tag: "span"
        }, {
          performanceDetail: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.performanceDetail')), 1)
          ]),
          quality: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.quality')), 1)
          ]),
          coverage: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.coverage')), 1)
          ]),
          qualityGate: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.qualityGate')), 1)
          ]),
          codeReview: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.codeReview')), 1)
          ]),
          harnessEngineering: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.harnessEngineering')), 1)
          ]),
          sdd: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.sdd')), 1)
          ]),
          cursor: _withCtx(() => [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.highlights.cursor')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: "sr-only",
        "aria-label": _ctx.$t('about.sr.stackHeading')
      }, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('about.sr.stackHeading')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skillKeywords), (items, key) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t(`about.sr.categories.${key}`)), 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (kw) => {
                return (_openBlock(), _createElementBlock("li", { key: kw }, _toDisplayString(kw), 1))
              }), 128))
            ])
          ], 64))
        }), 128))
      ], 8, _hoisted_8),
      _createElementVNode("div", {
        class: "sr-only",
        "aria-label": _ctx.$t('about.sr.coursesHeading')
      }, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('about.sr.coursesHeading')), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(courses), (course) => {
            return (_openBlock(), _createElementBlock("li", {
              key: course.id
            }, _toDisplayString(_unref(pick)(course.i18n).title) + " · " + _toDisplayString(_unref(pick)(course.i18n).institution), 1))
          }), 128))
        ])
      ], 8, _hoisted_9)
    ])
  ]))
}
}

})